import axios from 'axios';
export default {
	check(number) {
		return axios.get(`/apps/composite/api/carsweepstakes/check/${number}`);
	}
};
